import { FAQ, getStaticProps } from 'routes/public/FAQ'

export { getStaticProps }

export default FAQ
